const URL_MASK_MEMBERSHIP_ID = '{{ membership.id }}';
const URL_MASK_LAT = '{{ lat }}';
const URL_MASK_LNG = '{{ lng }}';

export const createIframeUrl = (params: {
  urlTemplate: string;
  membershipId: string;
  location: { lat: number; lng: number } | null;
}): string => {
  const { urlTemplate, membershipId, location } = params;
  let result = urlTemplate.replace(URL_MASK_MEMBERSHIP_ID, membershipId);

  if (location) {
    result = result.replace(URL_MASK_LAT, location.lat.toString());
    result = result.replace(URL_MASK_LNG, location.lng.toString());
  } else {
    result = result.replace(URL_MASK_LAT, '');
    result = result.replace(URL_MASK_LNG, '');
  }

  return result;
};
